// UserDetails/StatusActions/UserStatusActions.jsx

import React, { useState } from "react";

export default function UserStatusActions({ status, onChange }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  const normalizedStatus = status?.toUpperCase();
  // [label, valueToSend, color]
  const buttons =
    {
      PENDING: [
        ["ACCEPT", "accepted", "bg-green-600"],
        ["REJECT", "rejected", "bg-red-600"],
        ["HOLD", "hold", "bg-yellow-500"],
      ],
      HOLD: [
        ["ACCEPT", "accepted", "bg-green-600"],
        ["REJECT", "rejected", "bg-red-600"],
      ],
      REJECTED: [
        ["ACCEPT", "accepted", "bg-green-600"],
        ["HOLD", "hold", "bg-yellow-500"],
      ],
      ACCEPTED: [
        ["HOLD", "hold", "bg-yellow-500"],
        ["REJECT", "rejected", "bg-red-600"],
      ],
    }[normalizedStatus] || [];

  const handleStatusChange = async (newStatus) => {
    try {
      setIsUpdating(true);
      setUpdateError(null);
      await onChange(newStatus);
    } catch (error) {
      setUpdateError(error.message || 'Failed to update user status');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="space-y-3">
      {/* Error Message */}
      {updateError && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-md">
          <div className="text-red-600 text-sm">{updateError}</div>
          <button
            onClick={() => setUpdateError(null)}
            className="text-red-500 hover:text-red-700 text-xs mt-1"
          >
            ✕ Dismiss
          </button>
        </div>
      )}

      <div className="flex gap-4">
        {buttons.map(([label, value, color]) => (
          <button
            key={label}
            className={`px-6 py-2 rounded-md text-white font-bold hover:brightness-110 transition ${color} ${
              isUpdating ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            onClick={() => handleStatusChange(value)}
            disabled={isUpdating}
          >
            {isUpdating ? (
              <div className="flex items-center justify-center space-x-2">
                <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
                <span>Updating...</span>
              </div>
            ) : (
              label
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
